// extracted by mini-css-extract-plugin
export default {"block":"Fj","loading":"Gj","spinner":"Hj","spin":"Ij"};